<template>
  <svg width="24" height="24" viewBox="0 0 500 500" fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M102 23.3571C108.786 -7.64286 152.964 -7.85714 160.036 23.1071L160.393 24.6786L161.107
      27.75C165.42 46.1021 175.032 62.7819 188.747 75.7162C202.463 88.6505 219.677 97.2688 238.25
      100.5C270.571 106.107 270.571 152.536 238.25 158.143C219.572 161.392 202.27 170.089 188.52
      183.14C174.769 196.192 165.182 213.017 160.964 231.5L160.036 235.536C152.964 266.5 108.821
      266.286 102 235.286L101.286 231.821C97.224 213.276 87.7311 196.361 74.0173 183.232C60.3035
      170.103 42.9904 161.357 24.2857 158.107C-8 152.464 -8 106.179 24.2857 100.536C42.9192 97.2942
      60.172 88.5969 73.8599 75.5448C87.5478 62.4927 97.0552 45.6727 101.179 27.2143L101.75
      24.6786L102 23.3571ZM379.857 129.143C389.751 124.988 400.665 123.9 411.185 126.021C421.705
      128.141 431.345 133.372 438.857 141.036L438.929 141.071L484.143 186.679C489.143 191.656
      493.11 197.572 495.817 204.087C498.524 210.602 499.917 217.588 499.917 224.643C499.917
      231.698 498.524 238.683 495.817 245.198C493.11 251.713 489.143 257.63 484.143 262.607L484.071
      262.679L262.75 485.429C259.771 488.432 255.822 490.28 251.607 490.643L144.464 499.929C141.871
      500.152 139.26 499.805 136.814 498.913C134.369 498.021 132.148 496.605 130.307
      494.764C128.467 492.923 127.051 490.703 126.159 488.257C125.267 485.812 124.92 483.201
      125.143 480.607L134.429 373.464C134.792 369.25 136.64 365.301 139.643 362.321L362.393
      141C367.36 135.932 373.32 131.902 379.857 129.143Z"
      fill="currentColor"/>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
